import api from './api';

// Staff API functions
export const staffService = {
  // Get all staff members
  getStaff: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(`/staff${queryString ? `?${queryString}` : ''}`);
    return response.data;
  },

  // Get staff member by ID
  getStaffMember: async (id: string) => {
    const response = await api.get(`/staff/${id}`);
    return response.data;
  },

  // Create new staff member
  createStaffMember: async (staffData: any) => {
    const response = await api.post('/staff', staffData);
    return response.data;
  },

  // Update staff member
  updateStaffMember: async (id: string, staffData: any) => {
    const response = await api.put(`/staff/${id}`, staffData);
    return response.data;
  },

  // Delete staff member (soft delete)
  deleteStaffMember: async (id: string) => {
    const response = await api.delete(`/staff/${id}`);
    return response.data;
  },

  // Change staff member password
  changePassword: async (id: string, password: string) => {
    const response = await api.put(`/staff/${id}/password`, { password });
    return response.data;
  },

  // Change staff member role
  changeRole: async (id: string, role: string) => {
    const response = await api.put(`/staff/${id}/role`, { role });
    return response.data;
  },

  // Update last login
  updateLastLogin: async (id: string) => {
    const response = await api.put(`/staff/${id}/login`);
    return response.data;
  },

  // Get available roles
  getAvailableRoles: async () => {
    const response = await api.get('/staff/meta/roles');
    return response.data;
  }
};

export default staffService;